import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=0485675c&scoped=true"
import script from "./addMessage.vue?vue&type=script&lang=js"
export * from "./addMessage.vue?vue&type=script&lang=js"
import style0 from "./addMessage.vue?vue&type=style&index=0&id=0485675c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485675c",
  null
  
)

export default component.exports